import React, { useContext, useEffect, useRef, useState } from 'react'
import '../Login/Login.css'
import { User } from '../App'
import { useNavigate } from 'react-router-dom'
import CryptoJS from "crypto-js";
import Swal from 'sweetalert2'
import jwt_decode from "jwt-decode";
import { GoogleLogin, googleLogout } from '@react-oauth/google';
//npm i crypto-js
const Login = () => {
  const utente = useContext(User)
  const link = useNavigate()
  const nome = useRef(null)
  const password = useRef(null)
  const ricorda = useRef(null)
  const secretPass = "U76kfdher82"
  let controlloUtente = false
  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem("username") && localStorage.getItem("pwd")) {
      nome.current.value = localStorage.getItem("username")
      const bytes = CryptoJS.AES.decrypt(localStorage.getItem("pwd"), secretPass);
      const pwddecrypt = bytes.toString(CryptoJS.enc.Utf8);
      password.current.value = pwddecrypt
      ricorda.current.checked = true

    }
  }, [])
  const onSuccess = (credentialResponse) => {
    const userObject = jwt_decode(credentialResponse.credential);
    console.log('Utente Google:', userObject);

    sessionStorage.setItem("token", credentialResponse.credential);
    sessionStorage.setItem("userName", userObject.name);

    navigate("/citta");
  };

  const onError = () => {
    alert("Login fallito. Riprova.");
  };

  const controlla = () => {

    let flag = false
    let flag2 = false
    if (nome.current.value == "" || nome.current.value == undefined) {
      Swal.fire({ title: 'Nome utente obbligatorio!', timer: 1500, showConfirmButton: false, icon: 'warning', width: "65vw" })
    } else {
      flag = true
    }
    if (password.current.value == "" || password.current.value == undefined) {
      Swal.fire({ title: 'Password obbligatoria!', timer: 1500, showConfirmButton: false, icon: 'warning', width: "65vw" })
    } else {
      flag2 = true
    }
    if (flag && flag2) {
      inviaParametri()
    }
  }
  const inviaParametri = async () => {
    if (ricorda.current.checked) {
      localStorage.setItem("username", nome.current.value.toLowerCase())
      localStorage.setItem("pwd", await CryptoJS.AES.encrypt(password.current.value, secretPass))
    } else {
      localStorage.removeItem("pwd")
      localStorage.removeItem("usarname")
    }
    const link = 'http://37.60.34.42:8080/loginobelix'
    let parLogin = { nome: nome.current.value.toLowerCase(), pwd: password.current.value }

    await fetch(link, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ mieiDati: parLogin })
    })
      .then(response => response.json())
      .then((dati) => {

        if (dati.esito == "OK") {
          sessionStorage.setItem("token", dati.token)
          controlloUtente = true
          apri()

        } else {
          controlloUtente = true
          Swal.fire({ title: 'Controlla Utente o Password ', timer: 1500, showConfirmButton: false, icon: 'warning', width: "65vw" })
        }

      })
      .catch((err) => {
        Swal.fire({ title: 'Server non raggiungibile!', timer: 1500, showConfirmButton: false, icon: 'warning', width: "65vw" })
      })
    // const bytes = CryptoJS.AES.decrypt(localStorage.getItem("pwd"), secretPass);
    // const data = bytes.toString(CryptoJS.enc.Utf8);

    if (controlloUtente == false) {
      Swal.fire({ title: 'Controlla Utente o Password ', timer: 1500, showConfirmButton: false, icon: 'warning', width: "65vw" })
    } else {
      controlloUtente = false
    }
  }
  const apri = () => {
    link("/citta")
  }
  const Contatti = () => {
    link("/contattami")
  }
  return (
    //Inizio login
    <div id='contLogin'>
      {/* Introduzione*/}
      <div className='log'>

          <form>


            <div className="mainContainer">
              <div id='contLogin'>
                <div className='log'>
                  <div className='contenitoreLogin'>
                    <form>
                      <div className="headingsContainer">
                        <h1 className="mangiuma-elegant">MANGIUMA!</h1>
                        <h2 className='color'>Il tuo pranzo in un CLICK!</h2>
                      </div>
                      <div className="mainContainer">
                        {/* Bottone Google OAuth */}
                        <GoogleLogin
                          onSuccess={onSuccess}
                          onError={onError}
                          useOneTap
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <p className="register">Password dimenticata? <a href="#" onClick={Contatti}>Contattami!</a></p>
            </div>
          </form>
      </div>

    </div>
  )
}

export default Login


